export { default as ReduceMotionToggle } from './ReduceMotionToggle';